import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "24",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.5 13.441L7.28446 15.01C7.54995 15.5409 7.68269 15.8064 7.86003 16.0365C8.01739 16.2406 8.20041 16.4236 8.40455 16.581C8.63462 16.7583 8.9001 16.8911 9.43108 17.1566L11 17.941L9.43108 18.7255C8.9001 18.991 8.63462 19.1237 8.40455 19.3011C8.20041 19.4584 8.01739 19.6414 7.86003 19.8456C7.68269 20.0757 7.54995 20.3411 7.28446 20.8721L6.5 22.441L5.71554 20.8721C5.45005 20.3411 5.31731 20.0757 5.13997 19.8456C4.98261 19.6414 4.79959 19.4584 4.59545 19.3011C4.36538 19.1237 4.0999 18.991 3.56892 18.7255L2 17.941L3.56892 17.1566C4.0999 16.8911 4.36538 16.7583 4.59545 16.581C4.79959 16.4236 4.98261 16.2406 5.13997 16.0365C5.31731 15.8064 5.45005 15.5409 5.71554 15.01L6.5 13.441Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15 2.44104L16.1786 5.50546C16.4606 6.23869 16.6016 6.6053 16.8209 6.91368C17.0153 7.18699 17.254 7.42579 17.5274 7.62013C17.8357 7.8394 18.2024 7.98041 18.9356 8.26242L22 9.44104L18.9356 10.6197C18.2024 10.9017 17.8357 11.0427 17.5274 11.262C17.254 11.4563 17.0153 11.6951 16.8209 11.9684C16.6016 12.2768 16.4606 12.6434 16.1786 13.3766L15 16.441L13.8214 13.3766C13.5394 12.6434 13.3984 12.2768 13.1791 11.9684C12.9847 11.6951 12.746 11.4563 12.4726 11.262C12.1643 11.0427 11.7976 10.9017 11.0644 10.6197L8 9.44104L11.0644 8.26242C11.7976 7.98041 12.1643 7.8394 12.4726 7.62013C12.746 7.42579 12.9847 7.18699 13.1791 6.91368C13.3984 6.6053 13.5394 6.23869 13.8214 5.50546L15 2.44104Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }